import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { CanActivateFn } from '@angular/router';

export const AuthGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);
  
  console.log(`[AuthGuard] Checking route: ${state.url}`);

  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      unsubscribe();
      if (user) {
        console.log(`[AuthGuard] User authenticated, allowing navigation to: ${state.url}`);
        resolve(true);
      } else {
        console.log(`[AuthGuard] User not authenticated, redirecting to login from: ${state.url}`);
        router.navigate(['/login']);
        resolve(false);
      }
    });
  });
}; 